import React from 'react';
import { Button } from 'react-bootstrap';
import { FaFolder, FaTrash } from 'react-icons/fa';
import { LogoType } from '../../../static/types/commonTypes/logoType';

const API_URL = process.env.REACT_APP_API_BASE;

interface LogosSectionProps {
  logos: LogoType[];
  selectedLogos: number[];
  primaryColor: string;
  onLogoSelection: (logoId: number) => void;
  onSelectAllLogos: () => void;
  onOpenDeleteModal: () => void;
}

const LogosSection: React.FC<LogosSectionProps> = ({
  logos,
  selectedLogos,
  primaryColor,
  onLogoSelection,
  onSelectAllLogos,
  onOpenDeleteModal,
}) => {
  if (logos.length === 0) {
    return (
      <div style={{ marginTop: 20, padding: '15px', background: '#f8f9fa', borderRadius: '8px' }}>
        <div className="text-center text-muted py-4">
          <FaFolder size={48} className="mb-3" style={{ opacity: 0.3 }} />
          <p>Aucun logo disponible pour cet utilisateur</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ marginTop: 20, padding: '15px', background: '#f8f9fa', borderRadius: '8px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        <h5 style={{ color: primaryColor, marginBottom: 0 }}>
          <FaFolder className="me-2" />
          Logos de l'utilisateur ({logos.length})
        </h5>

        <div style={{ display: 'flex', gap: '10px' }}>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={onSelectAllLogos}
          >
            {selectedLogos.length === logos.length ? 'Tout désélectionner' : 'Tout sélectionner'}
          </Button>
          <Button
            style={{ backgroundColor: '#dc3545', border: 'none' }}
            size="sm"
            onClick={onOpenDeleteModal}
            disabled={selectedLogos.length === 0}
          >
            <FaTrash className="me-2" />
            Supprimer ({selectedLogos.length})
          </Button>
        </div>
      </div>

      <div className="logos-container">
        {logos.map((logo) => {
          if (!logo || !logo.libelle) {
            return null;
          }

          const isSelected = selectedLogos.includes(logo.id);
          const raw = logo.libelle;

          let src: string;
          if (raw.startsWith('http://') || raw.startsWith('https://')) {
            src = raw;
          } else if (raw.startsWith('blob:')) {
            src = raw;
          } else {
            const baseUrl = (API_URL || '').replace(/\/$/, '');
            const path = raw.replace(/^\//, '');
            src = `${baseUrl}/${path}`;
          }

          return (
            <div
              key={logo.id}
              onClick={() => onLogoSelection(logo.id)}
              className={`logo-item ${isSelected ? 'selected' : ''}`}
            >
              <div className="select-badge">
                {isSelected && <span style={{ fontSize: '20px' }}>✓</span>}
              </div>

              <img
                src={src}
                alt={`Logo ${logo.id}`}
                className="logo-image"
                onError={(e) => {
                  const target = e.currentTarget as HTMLImageElement;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent && !parent.querySelector('.error-message')) {
                    const errorDiv = document.createElement('div');
                    errorDiv.className = 'error-message';
                    errorDiv.style.cssText = 'display: flex; align-items: center; justify-content: center; height: 100%; color: #999; text-align: center; padding: 10px;';
                    errorDiv.textContent = 'Image non disponible';
                    parent.appendChild(errorDiv);
                  }
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LogosSection;